"use client";

import { useTranslations } from "next-intl";
import { FilterMealsItem } from "@/features/filters/components/filter-meals-item";
import {
  FilterMulti,
  type FilterMultiProps,
} from "@/features/filters/components/filter-multi/filter-multi";
import type { FilterMultiType } from "@/features/filters/types/filter-multi.type";
import type { FiltersSetup } from "@/features/filters/types/filters-setup.type";

type FilterMealsProps = Omit<FilterMultiProps, "filter" | "paramName"> & {
  filtersSetup: FiltersSetup;
  filter?: FilterMultiType;
  paramName?: string;
};

export const FilterMeals = (params: FilterMealsProps) => {
  const { filtersSetup, collapsible, paramName = "preset", ...rest } = params;
  const t = useTranslations();

  return (
    <FilterMulti
      collapsible={collapsible}
      collapsibleButtonLabel={t("filters.expand")}
      filter={{
        label: t("filters.labels.numberOfMeals"),
        name: paramName,
        total: filtersSetup.meals.length,
        value: [],
        options: filtersSetup.presets.map((item) => ({
          label: (
            <FilterMealsItem
              data={{
                title: t(`filters.presets.${item.option}.title`),
                numberOfMeals: t(
                  `filters.presets.${item.option}.numberOfMeals`,
                ),
                description: t(`filters.presets.${item.option}.description`),
              }}
            />
          ),
          value: item.option,
        })),
      }}
      listWrapperClass="[&>div]:basis-full"
      multiple={false}
      paramName={paramName}
      stretch={true}
      type="button"
      {...rest}
    />
  );
};
